export default __webpack_public_path__ + "b88a594c13e4600e33f07290a9a991ce.png";